// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1-AVF","label":"SetPasswdForm_label__2WIlv"};